import _has from "lodash/has";
import _isPlainObject from "lodash/isPlainObject";
import _isUndefined from "lodash/isUndefined";
import _isString from "lodash/isString";
import _each from "lodash/each";
import _isArray from "lodash/isArray";
import compareSemvers, { validateSemver } from './compare-semvers';
var MIN_VERSION = '1.0.0';
export function validateSchemaDefinition(_ref) {
  var nodeProps = _ref.nodeProps,
      version = _ref.version,
      migrations = _ref.migrations;
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Make sure to pass a string for the `type` argument to validateSchemaBlock';

  // nodeProps shape
  if (!_isArray(nodeProps)) {
    throw new Error("type: ".concat(type, " - 'nodeProps' array is required, got: ").concat(nodeProps));
  }

  _each(nodeProps, function (propName) {
    if (!_isString(propName)) {
      throw new Error("type: ".concat(type, " - 'nodeProps' - nodeProp must be a string, got: ").concat(propName));
    }
  }); // validate semvers


  if (_isUndefined(version)) throw new Error("type: ".concat(type, " - 'version' - version must be defined")); // version must be at least minimum version.

  if (compareSemvers(version, MIN_VERSION) === -1) {
    throw new Error("type: ".concat(type, " - 'version' - version must be at least ").concat(MIN_VERSION));
  } // migrations object must exist


  if (!_isPlainObject(migrations)) {
    throw new Error("type: ".concat(type, " - 'migrations' - migrations must be defined as a plain object"));
  } // migrations must be defined for versions greater than MIN_VERSION


  if (compareSemvers(version, MIN_VERSION) === 1 && !_has(migrations, version)) {
    throw new Error("type: ".concat(type, " - 'migrations' - valid migration for ").concat(version, " must be defined"));
  } // migrations must keyed by valid semver


  _each(migrations, function (getMigrator, migrationVersion) {
    try {
      validateSemver(migrationVersion);
    } catch (err) {
      throw new Error("type: ".concat(type, " - 'migrations' - ").concat(migrationVersion, " not a valid semver: ").concat(err.message));
    }

    if (compareSemvers(migrationVersion, version) === 1) {
      throw new Error("type: ".concat(type, " - 'migrations' - migrator <").concat(migrationVersion, "> will never be run, as it is greater than schema version: ").concat(version));
    }
  });
}
export default function validateSchema(schema) {
  _each(schema, function (definition, type) {
    return validateSchemaDefinition(definition, type);
  });
}
export function schemaPropType(props, propName, componentName) {
  try {
    validateSchema(props[propName]);
    return undefined;
  } catch (err) {
    err.message = "<".concat(componentName, " />, props.").concat(propName, ": ").concat(err.message);
    return err;
  }
}